import { React, ts } from '_core';

import Chart from './chart';

type TreeModelsAlphaSignalImportanceProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  fullScreen?: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  context?: ts.types.signal.SignalAnalysisContext;
  widgetPaths: Record<'tree_models_importance', string>;
  title: string;
};

const TreeModelsAlphaSignalImportance = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
}: TreeModelsAlphaSignalImportanceProps) => {
  return (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      file={widgetPaths['tree_models_importance']}
      fullScreen={fullScreen}
      title={title}
    />
  );
};

export default TreeModelsAlphaSignalImportance;
